export function isSystemManagedChecklistItem(item) {
    return Boolean(item?.system_managed) || item?.checklist_type === "LOCKER_CODE_ROTATION";
}

export function preserveSystemManagedChecklistItems(originalItems = [], draftItems = []) {
    const originalById = new Map(
        originalItems
            .filter(item => item.id != null)
            .map(item => [item.id, item])
    );
    const protectedIds = new Set(
        originalItems
            .filter(isSystemManagedChecklistItem)
            .map(item => item.id)
            .filter(id => id != null)
    );
    const next = draftItems.map(item => {
        if (item.id != null && protectedIds.has(item.id)) {
            return originalById.get(item.id);
        }
        return item;
    });
    const includedIds = new Set(next.map(item => item.id).filter(id => id != null));
    originalItems.forEach(item => {
        if (isSystemManagedChecklistItem(item) && item.id != null && !includedIds.has(item.id)) {
            next.push(item);
        }
    });
    return next;
}
